<template>
  <router-link tag="div" :to="pathName ? pathName : {name: link}" class="channelCard" :style="{backgroundImage: 'url(' + image + ')'}">
    <div class="overlay" v-if="isDisable"></div>
    <div class="channelCard__title" :class="{disable: isDisable}">
      <i v-if="isDisable">
        <svg width="16px" height="16px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs></defs>
            <g id="style-guide" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="icon-set" transform="translate(-82.000000, -242.000000)">
                    <g id="icon/ic_time_load" transform="translate(80.000000, 240.000000)">
                        <g id="ic_time"></g>
                        <g id="three-quarters-of-an-hour" transform="translate(2.000000, 2.000000)" fill="#262626">
                            <path d="M5.99938854,2.5477707e-05 C2.69143949,2.5477707e-05 0,2.6913121 0,5.99938854 C0,9.30738854 2.69146497,11.9986242 5.99941401,11.9986242 C9.30738854,11.9986242 11.9986752,9.30738854 11.9986752,5.99938854 C11.9986497,2.6913121 9.3073121,2.5477707e-05 5.99938854,2.5477707e-05 Z M5.99938854,10.6051975 C3.45966879,10.6051975 1.39345223,8.53898089 1.39345223,5.99936306 C1.39345223,3.45964331 3.45969427,1.3933758 5.99938854,1.3933758 C8.53918471,1.3933758 10.6052484,3.45964331 10.6052484,5.99936306 C10.6052484,8.53903185 8.53915924,10.6051975 5.99938854,10.6051975 Z" id="Shape" fill-rule="nonzero"></path>
                            <path d="M5.99938854,1.92575796 C5.99610191,1.92575796 5.99273885,1.92593631 5.98942675,1.92593631 L5.98942675,5.95987261 L1.92680255,5.95987261 C1.92670064,5.97309554 1.92583439,5.98614013 1.92583439,5.99938854 C1.92583439,8.24550318 3.7531465,10.0729427 5.99941401,10.0729427 C8.24552866,10.0729427 10.0729682,8.24547771 10.0729682,5.99938854 C10.0729427,3.7531465 8.24547771,1.92575796 5.99938854,1.92575796 Z" id="Shape" fill-rule="nonzero"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
      </i>
      <h2 class="large-font" :style="{color: color}">{{title | capitalizing}}</h2>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'adx-channel-card',
  props: {
    title: { required: true },
    image: { required: true },
    color: { required: true },
    isDisable: { required: false },
    link: { required: false },
    pathName: {required: false}
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>